import { useStore } from 'vuex';

let PaymentCallbackHandler = null;
let canalPago = '181';

// Importar SDK dinámicamente
import('@gdev/card-payment')
  .then(module => {
    if (module.PaymentCallbackHandler) {
      PaymentCallbackHandler = module.PaymentCallbackHandler;
      console.log('✅ PaymentCallbackHandler importado');
    }
  })
  .catch(err => console.warn('⚠️ No se pudo importar PaymentCallbackHandler:', err));

export function getPaymentCallbackHandler() {
  return PaymentCallbackHandler;
}

export function usePaymentCallback() {
  const store = useStore();

  const cleanUrl = () => {
    // Limpiar URL sin recargar la página
    const cleanPath = window.location.pathname;
    window.history.replaceState({}, document.title, cleanPath);
    console.log('🧹 URL limpiada');
  };

  const processBanamexCallback = async (callbackResult) => {
    const params = new URLSearchParams(window.location.search);
    const cardOperation = localStorage.getItem('card_operation');

    console.log('✅ Procesando callback de Banamex');

    try {
      if (callbackResult?.success && callbackResult.data) {
        await sendBanamexTransaction(callbackResult, cardOperation, params);
      } else {
        await processFallbackCallback(cardOperation, params);
      }

      sessionStorage.setItem('banamex_callback_processed', 'true');
      cleanUrl();
      return true;
    } catch (error) {
      console.error('❌ Error procesando callback:', error);
      store.commit('SET_ERROR_SUBSCRIPTION', 'Error al procesar el pago. Por favor contacta a soporte.');
      cleanUrl();
      return false;
    }
  };

  const sendBanamexTransaction = async (result, cardOperation, params) => {
    const sdkData = result.data;
    const operationData = cardOperation ? JSON.parse(cardOperation) : null;
    const folioData = store.getters.getFolio?.dataObj || {};

    const banamexData = {
      orderId: folioData.folio || operationData?.folio,
      cliente: folioData.folio || operationData?.folio || 'VENTA_NUEVA',
      monto: operationData?.monto || '1.00',
      canalPago: canalPago,
      currentStatus: 'approved',
      authCode: params.get('resultIndicator') || '',
      reference: sdkData.idOrder || 'ORDER_' + Date.now(),
      productDesc: 'Pago suscripcion DISH',
      canalOrigen: '1',
      idConcepto: ''
    };

    await store.dispatch('tranRecibidaBanamex', banamexData);
    localStorage.removeItem('card_operation');
    console.log('✅ Transacción registrada');
  };

  const processFallbackCallback = async (cardOperation, params) => {
    const operationData = cardOperation ? JSON.parse(cardOperation) : null;
    
    if (!operationData) {
      console.error('❌ No hay datos de operación');
      return;
    }

    const folioData = store.getters.getFolio?.dataObj || {};
    const pathParts = window.location.pathname.split('/');
    const transactionId = pathParts[pathParts.length - 1];

    const banamexData = {
      cliente: folioData.folio || operationData.folio || 'VENTA_NUEVA',
      orderId: folioData.folio || operationData.folio,
      canalPago: canalPago,
      currentStatus: 'approved',
      authCode: params.get('resultIndicator') || '',
      monto: operationData.monto || '1.00',
      reference: transactionId,
      productDesc: 'Pago suscripcion DISH',
      canalOrigen: '1',
      idConcepto: ''
    };

    await store.dispatch('tranRecibidaBanamex', banamexData);
    localStorage.removeItem('card_operation');
    console.log('✅ Transacción registrada (fallback)');
  };

  return {
    processBanamexCallback
  };
}
